<div class="flex flex-col gap-2xl" [class]="floatingPageClasses()">
  <header class="flex flex-wrap items-end justify-between gap-xl">
    <div>
      <p class="m-0 text-xs font-medium uppercase text-neutral-500">
        {{ dateLine }}
      </p>
      <h1 class="m-0 mt-x-sm text-2xl font-semibold text-neutral-900">
        @if (firstName) {
          {{ greeting | transloco: { name: firstName } }}
        } @else {
          {{ 'employee_home_greeting_no_name' | transloco }}
        }
      </h1>
    </div>
    <div class="flex gap-md">
      <a
        class="rounded-lg bg-primary-500 px-xl py-sm text-sm font-medium text-white"
        [routerLink]="newRequestLink">
        {{ 'employee_home_new_request' | transloco }}
      </a>
      <a
        class="rounded-lg border border-neutral-300 bg-white px-xl py-sm text-sm font-medium text-neutral-700"
        [routerLink]="inboxLink">
        {{ 'sidenav_my_inbox_item_label' | transloco }}
      </a>
    </div>
  </header>

  <section
    class="grid gap-lg [grid-template-columns:repeat(auto-fill,minmax(14rem,1fr))]"
    data-test="home-insights">
    @for (tile of tiles(); track tile.key) {
      <a
        class="block h-full"
        [routerLink]="inboxLink"
        [queryParams]="tile.queryParams"
        [attr.data-test]="'tile-' + tile.key"
        [attr.aria-busy]="tile.value === undefined">
        @if (tile.value === undefined) {
          <div
            class="flex h-full min-h-28 w-full flex-col justify-between gap-lg rounded-lg border border-neutral-200 bg-white p-lg"
            data-test="tile-skeleton">
            <span class="text-xs font-medium text-neutral-900">
              {{ tile.label | transloco }}
            </span>
            <span class="h-7 w-14 rounded-md" libSkeleton></span>
          </div>
        } @else {
          <lib-stat
            [overline]="tile.label | transloco"
            [label]="tile.display"
            [iconSvgName]="tile.icon" />
        }
      </a>
    }
  </section>

  <section
    [class]="
      floating()
        ? 'floating-card floating-card-fit p-2xl'
        : 'rounded-lg bg-white p-2xl shadow-sm'
    "
    data-test="home-approvals"
    aria-labelledby="home-approvals-title">
    <div class="flex items-center justify-between gap-md">
      <h2
        id="home-approvals-title"
        class="m-0 text-lg font-semibold text-neutral-900">
        {{ 'employee_home_approvals_title' | transloco }}
      </h2>
      @if (awaitingCount()) {
        <span
          class="rounded-3xl bg-warning-50 px-sm py-x-sm text-sm font-medium text-warning-700">
          {{
            'employee_home_approvals_waiting'
              | transloco: { count: awaitingCount() }
          }}
        </span>
      }
    </div>

    @switch (approvals()) {
      @case (undefined) {
        <ul class="mt-xl mb-0 flex list-none flex-col p-0" aria-busy="true">
          @for (row of approvalSkeletonRows; track row) {
            <li
              class="flex items-center gap-md px-md py-md"
              data-test="approval-skeleton">
              <span class="size-6 rounded-full" libSkeleton></span>
              <span class="flex min-w-0 flex-1 flex-col gap-x-sm">
                <span class="h-4 w-2/5 rounded-md" libSkeleton></span>
                <span class="h-3 w-1/4 rounded-md" libSkeleton></span>
              </span>
              <span class="h-3 w-12 rounded-md" libSkeleton></span>
            </li>
          }
        </ul>
      }
      @case (null) {
        <p class="mt-xl mb-0 text-sm text-red-600" data-test="approvals-error">
          {{ 'employee_home_approvals_error' | transloco }}
        </p>
      }
      @default {
        @if (approvals()!.length === 0) {
          <div class="py-2xl text-center" data-test="approvals-empty">
            <p class="m-0 font-medium text-neutral-900">
              {{ 'employee_home_approvals_empty_title' | transloco }}
            </p>
            <p class="mt-x-sm mb-0 text-sm text-neutral-500">
              {{ 'employee_home_approvals_empty_body' | transloco }}
            </p>
          </div>
        } @else {
          <ul class="mt-xl mb-0 flex list-none flex-col p-0">
            @for (row of approvalRows(); track row.id) {
              <li data-test="approval-row">
                <a
                  class="flex items-center gap-md rounded-md px-md py-md hover:bg-neutral-50"
                  [routerLink]="row.link">
                  <lib-avatar
                    [fullName]="row.creatorName"
                    [img]="row.creatorImage" />
                  <div class="min-w-0 flex-1">
                    <p
                      class="m-0 truncate text-sm font-medium text-neutral-900">
                      {{ row.subject }}
                    </p>
                    <p class="m-0 truncate text-xs text-neutral-500">
                      {{ row.flowName }} · {{ row.stepName }}
                    </p>
                  </div>
                  @if (row.overdue) {
                    <span
                      class="size-2 rounded-full bg-red-500"
                      role="img"
                      data-test="overdue-dot"
                      [attr.aria-label]="
                        'employee_home_approvals_overdue' | transloco
                      "
                      [attr.title]="
                        'employee_home_approvals_overdue' | transloco
                      "></span>
                  }
                  <span class="shrink-0 text-xs text-neutral-500">{{
                    row.age
                  }}</span>
                </a>
              </li>
            }
          </ul>
          @if (showViewAll()) {
            <a
              class="mt-md inline-block text-sm font-medium text-primary-700"
              [routerLink]="inboxLink"
              [queryParams]="assignedTab">
              {{ 'employee_home_approvals_view_all' | transloco }}
            </a>
          }
        }
      }
    }
  </section>
</div>
